/* ============================================================
   byc-collapse.js
   Mike directive 2026-06-08 — replaces the old quick-build.js
   closest-CTA routing. Wires any in-page CTA that targets
   #build / #build-target, OR carries `[data-byc-trigger]`,
   to the NEAREST `.byclg` section in DOM order ("below first,
   fall back to above"). On click:
     - dispatch `byclg:expand` on the chosen BYC (the section's
       own handler removes data-byclg-collapsed if set, and
       smooth-scrolls the heading into view)
     - prevent the browser's default jump-to-id behaviour
   Single-BYC pages keep default browser hash behaviour.
   ============================================================ */
(function(){
  function init(){
    var bycs = Array.prototype.slice.call(
      document.querySelectorAll('section.byclg[data-section-id]')
    );
    if (!bycs.length) return;

    function chooseForCta(cta){
      // Prefer the first BYC that follows the CTA in document order;
      // fall back to the last BYC if the CTA is after all of them.
      for (var i = 0; i < bycs.length; i++) {
        var p = cta.compareDocumentPosition(bycs[i]);
        if (p & Node.DOCUMENT_POSITION_FOLLOWING) return bycs[i];
      }
      return bycs[bycs.length - 1];
    }

    function fire(byc){
      try {
        byc.dispatchEvent(new CustomEvent('byclg:expand', { bubbles: false }));
      } catch(_) {
        // IE11 fallback (not in scope but defensive)
        var ev = document.createEvent('Event');
        ev.initEvent('byclg:expand', false, false);
        byc.dispatchEvent(ev);
      }
    }

    function handler(e){
      // Walk up from the click target to find a matching CTA.
      var t = e.target;
      var cta = t.closest && t.closest(
        'a[href="#build"], a[href$="#build"], ' +
        'a[href="#build-target"], a[href$="#build-target"], ' +
        '[data-byc-trigger]'
      );
      if (!cta) return;
      // Skip CTAs that opt out (e.g. the teaser's own button — it has
      // its own per-instance handler).
      if (cta.hasAttribute('data-byclg-expand')) return;
      // Skip multi-BYC routing on single-BYC pages (let browser handle).
      if (bycs.length < 2 && !cta.hasAttribute('data-byc-trigger')) return;

      var explicit = cta.getAttribute('data-byc-trigger');
      var chosen = null;
      if (explicit) {
        // Explicit target wins. Value can be "first", "last", or a
        // section.id of a BYC instance.
        if (explicit === 'first') chosen = bycs[0];
        else if (explicit === 'last') chosen = bycs[bycs.length - 1];
        else {
          for (var i = 0; i < bycs.length; i++) {
            if (bycs[i].getAttribute('data-section-id') === explicit ||
                bycs[i].getAttribute('data-byclg-instance') === explicit) {
              chosen = bycs[i]; break;
            }
          }
        }
      }
      if (!chosen) chosen = chooseForCta(cta);
      if (!chosen) return;
      e.preventDefault();
      fire(chosen);
    }

    document.addEventListener('click', handler, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
